/* eslint-disable react/jsx-curly-newline */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable react/no-danger */
/**
 *
 * Component: MultiSelectFilter
 * Date: 7/8/2020
 *
 */

import React, { useEffect, useReducer, useRef, useCallback } from 'react';
// import Search from 'antd/lib/input/Search';
// import { Search } from 'components/common';
import dompurify from 'dompurify';
import _ from 'lodash';

import {
  Checkbox,
  Icon,
  Text,
  Button,
  Select,
  Option,
  Tooltip,
} from '../common';
import { FilterLayout } from '../index';

import styles from './style.module.css';

function reducer(
  state: { conditionState: any },
  action: {
    type: any;
    payload: {
      displayedSelectedValues: any;
      searchText?: any;
      displayedFilterValues?: any;
      selectedValuesState: any;
    };
  },
): any {
  switch (action.type) {
    case 'filterDisplayedValues': {
      const {
        displayedSelectedValues,
        searchText,
        displayedFilterValues,
        selectedValuesState,
      } = action.payload;
      return {
        ...state,
        displayedSelectedValues,
        searchText,
        displayedFilterValues,
        selectedValuesState,
      };
    }
    case 'selectFilterValue': {
      const { displayedSelectedValues, selectedValuesState } = action.payload;
      return {
        ...state,
        displayedSelectedValues,
        selectedValuesState,
      };
    }
    case 'setCondition': {
      return {
        ...state,
        conditionState: action.payload,
      };
    }
    case 'setRuleTypeState': {
      return {
        ...state,
        ruleTypeState: action.payload,
      };
    }
    case 'setCheckTypeState': {
      return {
        ...state,
        checkTypeState: action.payload,
      };
    }
    case 'setShowFilter': {
      return {
        ...state,
        showFilter: action.payload,
      };
    }
    case 'handleClose': {
      return {
        ...state,
        searchText: '',
        displayedFilterValues: [],
        selectedValuesState: [],
        displayedSelectedValues: [],
        showFilter: false,
        conditionState: state.conditionState || 'in',
      };
    }
    case 'updateSelectedValues': {
      return { ...state, selectedValuesState: action.payload };
    }
    case 'cancelChanges': {
      const { selectedValuesState } = action.payload;
      return {
        ...state,
        selectedValuesState,
      };
    }
    default:
      throw new Error();
  }
}

// eslint-disable-next-line sonarjs/cognitive-complexity
function MultiSelectFilter({
  filter = {},
  selectedValues,
  condition,
  ruleType,
  checkType,
  filterValues,
  tagRules,
  handleClear,
  onFilterApplied,
  moreFilter,
  hideTitle,
  multiSelectFilter,
  setShowMoreFilter,
  equalAndUnequalOptions,
}: any): JSX.Element {
  const multiSelectFilterRef = useRef<any>();
  const initialState = {
    displayedSelectedValues: [],
    searchText: '',
    displayedFilterValues: [],
    selectedValuesState: selectedValues || [],
    showFilter: false,
    conditionState: condition,
    ruleTypeState: ruleType,
    checkTypeState: checkType,
  };
  const [
    {
      displayedSelectedValues,
      searchText,
      displayedFilterValues,
      selectedValuesState,
      showFilter,
      conditionState,
      ruleTypeState,
      checkTypeState,
    },
    dispatch,
  ] = useReducer(reducer, initialState);
  // similar to initialState but from redux state.

  // useEffect(() => {
  //   console.log(state?.selectedValuesState || null); // similar to initialState but from redux state.
  // }, [state]);
  /**
   * This function is supposed to order selected values and remaining values in the list in ascending order one after other
   * @param -> {Array} filterArgs and {Array} selectedStateArgs
   * @return -> filtered, Grouped and merger Array.
   *
   */
  const functionForValuesOrder = useCallback(
    (filterArgs, selectedStateArgs) => {
      // TODO: use immer patch
      let newSelectedValues = filterArgs.filter((f: any) =>
        selectedStateArgs.includes(f._id),
      );
      const selectedValuesId = selectedStateArgs;
      const displayFilter = _.orderBy(
        filterArgs.filter((f: any) => {
          if (selectedValuesId.includes(f._id)) {
            return false;
          }
          return true;
        }),
        ['group', 'name'],
        ['asc', 'asc'],
      );

      newSelectedValues = _.orderBy(
        newSelectedValues,
        ['group', 'name'],
        ['asc', 'asc'],
      );

      return [...newSelectedValues, ...displayFilter];
    },
    [],
  );

  /**
   * this function is used to handle display selected values of drop down, which will change count shown and list of options showed
   *
   * @param -> {String} searchTextArgs and {Array} valuesArgs
   * @return -> Reducer action to update displayedSelectedValues, searchText, displayedFilterValues state
   *
   */
  const filterDisplayedValues = useCallback(
    (searchTextArgs: any, selectedValuesStateArgs: any): void => {
      let newdisplayedFilterValues: any = [];
      // this function is to set searched text bold in options
      const searchOption = searchTextArgs
        .trimLeft()
        .replace(RegExp('[!?+@#$%^&*_.]', 'g'), (match: any) => `\\${match}`);
      const testString = (s: any, b: any) => {
        if (s) {
          const match = RegExp(`(?:\\b|_)(${b})`, 'i').exec(s); // Test word boundary or starts with '_'
          if (match) return true;
        }
        return false;
      };

      const boldString = (s: any, b: any) => {
        // match[0] is full match whereas [1] is only the string without leading '_'
        const match = RegExp(`(?:\\b|_)(${b})`, 'i').exec(s) || ['', ''];
        return s.replace(RegExp(`${match[1]}`, 'i'), '<b>$&</b>'); // where '$&' returns matched substring
      };

      if (searchTextArgs) {
        filterValues.forEach((option: any) => {
          const matchInTagName = testString(option.name, searchOption);
          const matchInTagGroup = testString(option.group, searchOption);
          if (matchInTagGroup) {
            newdisplayedFilterValues.push({
              ...option,
              formattedGroup: (
                <span
                  dangerouslySetInnerHTML={{
                    __html: dompurify.sanitize(
                      `${boldString(option.group, searchOption)}/`,
                    ),
                  }}
                />
              ),
            });
          } else if (matchInTagName) {
            newdisplayedFilterValues.push({
              ...option,
              formattedName: (
                <span
                  dangerouslySetInnerHTML={{
                    __html: dompurify.sanitize(
                      boldString(option.name, searchOption),
                    ),
                  }}
                />
              ),
            });
          }
        });
      } else {
        newdisplayedFilterValues = _.cloneDeep(filterValues);
      }

      /**
       * added formattedName and formattedGroup to keep original values untouched which are used in tooltip etc
       * */
      const updatedSelectedValues =
        selectedValuesStateArgs || selectedValuesState;
      const displayedFilterValuesId = newdisplayedFilterValues.map(
        (f: any) => f._id,
      );
      const newdisplayedSelectedValues = updatedSelectedValues.filter(
        (id: any) => displayedFilterValuesId.includes(id),
      );

      newdisplayedFilterValues = _.cloneDeep(
        functionForValuesOrder(
          newdisplayedFilterValues,
          selectedValuesStateArgs || selectedValuesState,
        ),
      );

      dispatch({
        payload: {
          displayedSelectedValues: newdisplayedSelectedValues,
          searchText: searchTextArgs,
          displayedFilterValues: _.cloneDeep(newdisplayedFilterValues),
          selectedValuesState: selectedValuesStateArgs || selectedValuesState,
        },
        type: 'filterDisplayedValues',
      });
    },
    [filterValues, selectedValuesState, functionForValuesOrder],
  );

  useEffect(() => {
    filterDisplayedValues('', selectedValues);
  }, [selectedValues]);

  /**
   * Called every time an option is selected
   *
   * @param -> {Number} index of option and {Object} e for checked status
   * @return -> Reducer action to update items state
   *
   */
  const selectFilterValue = (index: any, e: any) => {
    let newSelectedValues = _.cloneDeep(selectedValuesState);
    let newDisplayedSelectedValues = _.cloneDeep(displayedSelectedValues);
    const filterValue = displayedFilterValues[index];
    newSelectedValues = newSelectedValues.filter(
      (selectedfilterValue: any) => filterValue._id !== selectedfilterValue,
    );
    newDisplayedSelectedValues = newDisplayedSelectedValues.filter(
      (selectedfilterValue: any) => filterValue._id !== selectedfilterValue,
    );
    if (e.target.checked) {
      newSelectedValues.push(filterValue._id);
      newDisplayedSelectedValues.push(filterValue._id);
    }
    dispatch({
      payload: {
        selectedValuesState: newSelectedValues,
        displayedSelectedValues: newDisplayedSelectedValues,
      },
      type: 'selectFilterValue',
    });
  };
  /**
   * Called every time when select all checkbox is clicked
   *
   * @param -> {Object} event for checked status
   * @return -> Reducer action to update items state
   *
   */
  const selectAllFilterValues = (event: any) => {
    const displayedFilterValuesId = displayedFilterValues.map(
      (f: any) => f._id,
    );
    let newSelectedValues;
    let newDisplayedSelectedValues;
    if (event.target.checked) {
      newSelectedValues = _.cloneDeep(displayedFilterValuesId);
      newDisplayedSelectedValues = _.cloneDeep(displayedFilterValuesId);
    } else {
      newSelectedValues = _.cloneDeep(selectedValuesState);
      newSelectedValues = newSelectedValues.filter(
        (id: any) => !displayedFilterValuesId.includes(id),
      );
      newDisplayedSelectedValues = [];
    }
    dispatch({
      payload: {
        displayedSelectedValues: newDisplayedSelectedValues,
        selectedValuesState: newSelectedValues,
      },
      type: 'selectFilterValue',
    });
  };
  /**
   * Function to get Button name as it is variable depending on selected values
   *
   * @return -> button name
   *
   */
  const getButtonName = () => {
    let selectedValue = selectedValues;
    if (multiSelectFilter) {
      // special case for multiple filter as it's data structure of selected values is different
      selectedValue = [];
      selectedValues.forEach((selectedArgs: any) => {
        if (selectedArgs.value) selectedValue.push(...selectedArgs.value);
      });
    }

    const getFilterNameFromId = (id: any) =>
      filterValues.find((filterArgs: any) => filterArgs._id === id)?.name || id;
    if (tagRules) {
      const prefix = checkTypeState === 'PRESENT' ? '' : 'EXCLUDES: ';
      if (selectedValue.length === 1) {
        return `${prefix} ${
          String(getFilterNameFromId(selectedValue[0])).indexOf('/') > -1
            ? String(getFilterNameFromId(selectedValue[0])).split('/')[1]
            : getFilterNameFromId(selectedValue[0])
        }`;
      }
      if (selectedValue.length > 1) {
        return `${prefix}${ruleTypeState} • ${selectedValue.length}`;
      }
    } else {
      const prefix = condition === 'not in' ? 'EXCLUDES: ' : '';

      if (selectedValue === undefined || selectedValue.length === 0) {
        return `${prefix}${filter.name}`;
      }
      if (selectedValue.length === 1) {
        return `${prefix}${filter.name} • ${
          String(getFilterNameFromId(selectedValue[0])).indexOf('/') > -1
            ? String(getFilterNameFromId(selectedValue[0])).split('/')[1]
            : getFilterNameFromId(selectedValue[0])
        }`;
      }
      if (selectedValue.length > 1) {
        return `${prefix}${filter.name} • ${selectedValue.length}`;
      }
    }
    return null;
  };

  const resetStateOfPlusButton = () => {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    if (!selectedValues?.length) handleClose();
  };

  const handleClose = () => {
    dispatch({
      type: 'handleClose' as any,
      payload: undefined as any,
    });
  };

  /**
   * @returns {JSX} for the filter Component UI based on Select Component.
   */
  const getFilter = (): any => (
    <div>
      {filterValues.length ? (
        <div>
          <div>
            {/* <Search
              allowClear
              autoFocus
              placeholder={`Search ${filter?.name || filter.field || ''}`}
              value={searchText}
              onChange={(e) => {
                filterDisplayedValues(e.target.value as any, undefined as any);
              }}
            /> */}
          </div>
          {equalAndUnequalOptions && (
            <div className={styles.filterConditions}>
              <Select
                defaultValue={condition}
                value={conditionState}
                onChange={(e: any) =>
                  dispatch({ type: 'setCondition', payload: e })
                }
              >
                <Option value="in" key="equal">
                  Equals
                </Option>
                <Option value="not in" key="not-equal">
                  Not Equals
                </Option>
              </Select>
            </div>
          )}
          {tagRules && (
            <div className={styles.tagRulesConditionsContainer}>
              <div className={styles.filterConditions}>
                <Select
                  defaultValue={ruleType}
                  value={ruleTypeState}
                  onChange={(e: any) =>
                    dispatch({ type: 'setRuleTypeState', payload: e })
                  }
                >
                  <Option value="ALL" key="ALL">
                    All
                  </Option>
                  <Option value="ANY" key="ANY">
                    Any
                  </Option>
                </Select>
              </div>
              <div className={styles.filterConditions}>
                <Select
                  defaultValue={checkType}
                  value={checkTypeState}
                  onChange={(e: any) =>
                    dispatch({ type: 'setCheckTypeState', payload: e })
                  }
                >
                  <Option value="PRESENT" key="PRESENT">
                    Present
                  </Option>
                  <Option value="ABSENT" key="ABSENT">
                    Absent
                  </Option>
                </Select>
              </div>
            </div>
          )}
          <div style={{ marginLeft: '.5rem', marginTop: '.5rem' }}>
            <Checkbox
              className="checkbox"
              checked={
                displayedSelectedValues.length > 0 &&
                displayedSelectedValues.length === displayedFilterValues.length
              }
              indeterminate={
                displayedSelectedValues.length > 0 &&
                displayedSelectedValues.length !== displayedFilterValues.length
              }
              onChange={selectAllFilterValues}
            />
            <span>
              {` ${displayedSelectedValues.length} of ${displayedFilterValues.length} selected`}
            </span>
            <hr className="divider" />
          </div>
          <div className={styles.multiselectFilterContent}>
            {displayedFilterValues.map((filterValue: any, index: any) => (
              <div key={filterValue._id}>
                <Checkbox
                  className="checkbox"
                  checked={selectedValuesState?.includes(filterValue._id)}
                  onChange={(e: any) => selectFilterValue(index, e)}
                >
                  <Tooltip
                    title={`${
                      filterValue?.group ? `${filterValue?.group}/` : ''
                    }${filterValue.name}`}
                    mouseEnterDelay={0.5}
                  >
                    {filterValue.group
                      ? filterValue.formattedGroup || `${filterValue.group}/`
                      : ''}
                    {filterValue.formattedName
                      ? filterValue.formattedName
                      : filterValue.name}
                  </Tooltip>
                </Checkbox>
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
  const handleClickOutside = () => {
    dispatch({ payload: false as any, type: 'setShowFilter' as any });
    handleListener(false);
  };

  /**
   * Handles listener apply and removal.
   * */
  const handleListener = (bool: any) => {
    if (bool) {
      document.addEventListener('mousedown', handleClickEvent);
    } else {
      document.removeEventListener('mousedown', handleClickEvent);
    }
  };

  /**
   * Detects if click is done outside of component or not.
   * */
  const handleClickEvent = (e: any) => {
    const path = e.path || (e.composedPath && e.composedPath());
    if (
      !path.includes(multiSelectFilterRef.current) &&
      !e.target.classList.value.includes('ant-select-dropdown-menu-item') &&
      e.target.classList.value !== 'ant-select-selection__rendered' &&
      e.target.classList.value !== 'ant-select-item-option-content' &&
      !e.target.classList.value.includes('ant-select-item')
    ) {
      // added extra conditions in if because of equal and not equal condition select option
      handleClickOutside();
    }
  };

  /**
   * Render a Filter Component, if showFIlter is true, else undefined,
   * */
  const getFilterComponent = () => {
    let component;
    if (showFilter) {
      component = (
        <FilterLayout
          onCancel={() => {
            dispatch({
              type: 'cancelChanges' as any,
              payload: { selectedValuesState: selectedValues } as any,
            });
            filterDisplayedValues('', selectedValues);
            handleClickOutside();
          }}
          onApply={() => {
            handleClickOutside();
            if (ruleTypeState) {
              onFilterApplied(
                selectedValuesState,
                ruleTypeState,
                checkTypeState,
              );
            } else {
              onFilterApplied(
                filter.field,
                selectedValuesState,
                conditionState,
              );
            }
            resetStateOfPlusButton();
          }}
        >
          {getFilter()}
        </FilterLayout>
      );
      // }
    }
    return component;
  };

  /**
   * Counts the total length of data present if flattened.
   * */
  const selectedValuesLength = () => {
    let totalLength = selectedValues?.length || 0;
    if (multiSelectFilter) {
      totalLength = 0;
      selectedValues.forEach((selectedArgs: any) => {
        totalLength += selectedArgs?.value?.length || 0;
      });
    } else if (tagRules) {
      return !(selectedValues === undefined || selectedValues.length === 0);
    }
    return totalLength;
  };

  return (
    <div ref={multiSelectFilterRef} className={styles.container}>
      <div className={styles.filterButtonContainer}>
        {moreFilter && !hideTitle && (
          <Text type="subtitle" text={filter?.name} />
        )}
        <div className="grid-column">
          <div className="filter-button">
            <Button
              id={!selectedValuesLength() ? 'plusBtn' : null}
              height="25px"
              iconSize={12}
              useAntd
              type={selectedValuesLength() ? 'chips' : 'chips-secondary'}
              icon={
                !selectedValuesLength() && (moreFilter || tagRules)
                  ? 'plus'
                  : null
              }
              onClick={() => {
                if (multiSelectFilter && selectedValues?.length > 1) {
                  setShowMoreFilter(true);
                } else {
                  dispatch({
                    type: 'setShowFilter' as any,
                    payload: !showFilter as any,
                  });
                  handleListener(!showFilter);
                }
              }}
              text={
                selectedValuesLength() || !moreFilter ? getButtonName() : ''
              }
            />
          </div>

          {filter.field !== 'tag' &&
            !tagRules &&
            moreFilter &&
            selectedValues?.length > 0 && (
              <Icon
                size={12}
                onClick={() => handleClear(filter.field)}
                type="delete"
              />
              // eslint-disable-next-line @typescript-eslint/indent
            )}
        </div>
      </div>
      {getFilterComponent()}
    </div>
  );
}
export default MultiSelectFilter;
